import { inject, Injectable } from '@angular/core';
import { ApiService } from './core/api.service';
import { Observable } from 'rxjs';
import { OrderDetails } from '../models/orders/order-basket-item.model';

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  private readonly api = inject(ApiService);

  getOrderDetails(orderId: string): Observable<OrderDetails> {
    return this.api.getAnySingle<OrderDetails>(`purchases/order/details/${orderId}`);
  }

  cancelOrder(orderId: string) {
    return this.api.post(`purchases/order/${orderId}/cancel`, {});
  }
}
